<!-- sidebar.component.html -->
<div class="sidebar" [@expandCollapse]="opened ? 'expanded' : 'collapsed'" [class.opened-mobile]="openedMobile" [class.closing-mobile]="isClosing">
  <!-- Add mobile close button -->
  <button *ngIf="openedMobile" 
          mat-icon-button 
          (click)="closeMobileSidebar()" 
          class="mobile-close-button">
    <mat-icon class="material-icons-outlined">close</mat-icon>
  </button>

  <a
    routerLink="/"
    class="logo"
    [class.opened]="opened"
    (click)="resetActiveItem(); handleNavigation()"
  >
    <img
      *ngIf="!opened"
      [class.closed]="!opened"
      loading="lazy"
      src="assets/img/flaredeck_logo_closed.svg"
      alt="Phiresky"
      [matTooltip]="version"
    />
    <img
      *ngIf="opened"
      [class.opened]="opened"
      loading="lazy"
      src="assets/img/flaredeck_logo_open.svg"
      alt="Phiresky"
      [matTooltip]="version"
    />
  </a>
  
  <div class="sidebar-header">
    <button mat-icon-button (click)="toggleSidebar()" class="toggle-button">
      <mat-icon class="material-icons-outlined">
        {{ opened ? "chevron_left" : "chevron_right" }}
      </mat-icon>
    </button>
  </div>

  <mat-nav-list class="menu-list">
    <ng-container *ngFor="let item of menuItems">
      <!-- Menu item without subitems -->
      <a
        mat-list-item
        *ngIf="!item.subItems"
        [routerLink]="item.link"
        [matTooltip]="!opened ? item.title : ''"
        matTooltipPosition="right"
        class="menu-item"
        [class.opened]="opened"
        routerLinkActive="active"
        (click)="handleNavigation()"
      >
        <div class="menu-content">
          <mat-icon class="menu-icon material-icons-outlined">{{ item.icon }}</mat-icon>
          <div class="menu-title" *ngIf="opened">{{ item.title }}</div>
        </div>
      </a>

      <!-- Menu item with subitems -->
      <ng-container *ngIf="item.subItems">
        <!-- Parent item - only show when expanded -->
        <a
          mat-list-item
          *ngIf="opened"
          (click)="toggleSubmenu(item.title)"
          class="menu-item parent-item"
          [class.active]="isSubmenuOpen(item.title)"
        >
          <div class="menu-content">
            <mat-icon class="menu-icon material-icons-outlined">{{ item.icon }}</mat-icon>
            <div class="menu-title">{{ item.title }}</div>
            <mat-icon class="submenu-indicator material-icons-outlined">
              {{ isSubmenuOpen(item.title) ? "expand_less" : "expand_more" }}
            </mat-icon>
          </div>
        </a>
        
        <!-- Subitems -->
        <ng-container *ngIf="!opened">
          <div class="drawer">
          <!-- Show only subitems when collapsed -->
          <a 
            mat-list-item 
            *ngFor="let subItem of item.subItems" 
            [routerLink]="subItem.link" 
            [matTooltip]="item.title + ': ' + subItem.title"
            matTooltipPosition="right"
            class="menu-item sub-item"
            routerLinkActive="active"
            (click)="handleNavigation()"
          >
            <div class="menu-content">
              <mat-icon [class.collapsed]="!opened" class="menu-icon material-icons-outlined">{{ subItem.icon }}</mat-icon>
            </div>
          </a>
          </div>
        </ng-container>

        <!-- Regular submenu when expanded -->
        <div 
          *ngIf="opened"
          class="submenu" 
          [@submenuAnimation]="isSubmenuOpen(item.title) ? 'open' : 'closed'"
        >
          <a 
            mat-list-item 
            *ngFor="let subItem of item.subItems" 
            [routerLink]="subItem.link" 
            class="submenu-item"
            routerLinkActive="active"
            (click)="handleNavigation()"
          >
            <div class="menu-content">
              <mat-icon class="menu-icon material-icons-outlined">{{ subItem.icon }}</mat-icon>
              <div class="menu-title">{{ subItem.title }}</div>
            </div>
          </a>
        </div>
      </ng-container>
    </ng-container>
  </mat-nav-list>
</div>
